import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { PaymentItemType } from './form-type';

export default function SummaryCard() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const [paymentItems] = useWatch({ control, name: ['paymentItems'] });

  const itemSummaries = React.useCallback(() => {
    const invoiceInfo = (paymentItems as PaymentItemType[])
      .filter((item) => item.isCheck)
      .reduce(
        (prev, item) => ({
          total: prev.total + item.total,
          paid: prev.paid + item.paidAmount,
          totalPayment: prev.totalPayment + item.amount,
          tax: prev.tax + item.tax,
          discount: prev.discount + item.discount,
          fee: prev.fee + item.fee,
        }),
        {
          total: 0,
          paid: 0,
          totalPayment: 0,
          tax: 0,
          discount: 0,
          fee: 0,
        },
      );

    return [
      {
        title: t('debt:total_invoice'),
        price: invoiceInfo.total,
      },
      {
        title: t('debt:total_paid'),
        price: invoiceInfo.paid,
      },
      {
        title: t('debt:total_payment'),
        price: invoiceInfo.totalPayment,
      },
      {
        title: t('debt:pph_subtotal'),
        price: invoiceInfo.tax,
      },
      {
        title: t('debt:discount_subtotal'),
        price: invoiceInfo.discount,
      },
      {
        title: t('debt:fee_subtotal'),
        price: invoiceInfo.fee,
      },
    ];
  }, [paymentItems, t]);
  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <Text variant="HeadingXSmall">{t('common:summary')}</Text>
      <SeparatorVertical $margin={24} />
      {itemSummaries().map((item) => (
        <>
          <FullContainer>
            <SectionContainer $style={{ alignItems: 'center' }}>
              <HalfContainer $style={{ flex: 1 }}>
                <Text variant="LabelSmall">{item.title}</Text>
              </HalfContainer>
              <HalfContainer $style={{ flex: 1, textAlign: 'right' }}>
                <Text variant="ParagraphSmall">
                  Rp {string2money(item.price)}
                </Text>
              </HalfContainer>
            </SectionContainer>
          </FullContainer>
          <SeparatorVertical $margin={24} />
        </>
      ))}
    </CardSection>
  );
}
